import { css } from '@/styled-system/css';

/*
 * Label and tooltip share the first grid row via named areas so both stay direct
 * children of FormField (no wrapper). All other slots span the full width.
 */
export const formFieldStyles = css.raw({
  'display': 'grid',
  'gridTemplateAreas': `
    "label tooltip"
  `,
  'gridTemplateColumns': 'auto 1fr',
  'justifyContent': 'start',

  '& > *': {
    gridColumn: '1 / -1',
  },

  '& > .c11n_label': {
    alignSelf: 'center',
    display: 'block',
    gridArea: 'label',
    marginBlockEnd: 'tightest',
  },

  '& > .c11n_tooltip__trigger': {
    alignSelf: 'center',
    gridArea: 'tooltip',
    marginBlockEnd: 'tightest',
    marginInlineStart: 'micro.default',
  },

  '& > .c11n_form-help': {
    marginBlockStart: 'tightest',
  },
});
